
(function () {
    "use strict";

    //
    // Validates the results based on the given options
    //
    function validate(result, dataJsSelector, options) {

        options = _.extend({ required: true, multiple: false }, options);

        if (result.length == 0 && options.required) {
            throw new Error(`No required data-js element(s) were found using selector "${dataJsSelector}", but options.required is true.`);
        } 

        if (result.length > 1 && !options.multiple) {
            throw new Error(`Multiple data-js elements were found using selector "${dataJsSelector}", but options.multiple is false.`);
        }

        return result;
    }

    //
    // Allows for a easier way to expose HTML elements to JavaScript via data - js attributes.
    // options.required - indicates if it is required that at least one element is selected (default true)
    // options.multiple - indicates if it is allowed that more than one element is selected (default false)
    //
	jQuery.js = function js(dataJsSelector, options) {
		return validate(jQuery(`[data-js~='${dataJsSelector}']`), dataJsSelector, options);
	};

    //
    // This allows for further filtering of a jQuery collection by data-js attributes
    // options.required - indicates if it is required that at least one element is selected (default true)
    // options.multiple - indicates if it is allowed that more than one element is selected (default false)
    //
    jQuery.fn.js = function js(dataJsSelector, options) {
        return validate(this.find(`[data-js~='${dataJsSelector}']`), dataJsSelector, options);
    };

    //
    // Analog to jquery .siblings() method, but selects siblings based on a data-js selector.
    //
    jQuery.fn.siblingsjs = function siblingsjs(dataJsSelector, options) {
        return validate(this.siblings(`[data-js~='${dataJsSelector}']`), dataJsSelector, options);
    }

    //
    // Analog to jquery .closest() method, but selects the closest based on a data-js selector.
    //
    jQuery.fn.closestjs = function closestjs(dataJsSelector, options) {
        return validate(this.closest(`[data-js~='${dataJsSelector}']`), dataJsSelector, options);
    }

    //
    // Allows checking if a jQuery object contains any DOM elements.  If it does, it just returns itself to facilitate chaining.
    //
    jQuery.fn.exists = function exists() {
        return this.length > 0 ? this : false;
    };

    //
    // Allows attaching a filtered event handler to a DOM element, filtering to the provided dataJsSelector
    // 
    jQuery.fn.onjs = function onjs(event, dataJsSelector, handler) {
        return this.on(event, `[data-js~='${dataJsSelector}']`, handler);
    };
})();
